/**
 * PC専用ホバー画像読み込みスクリプト
 * スマホ（768px以下）ではホバー画像を読み込まない
 * Googlebot（モバイル）のクロール効率とCore Web Vitalsを最適化
 */
(function() {
  'use strict';

  // PC判定（769px以上）
  var isDesktop = window.matchMedia('(min-width: 769px)').matches;

  // スマホの場合は何もしない
  if (!isDesktop) {
    // スマホではホバー画像要素を完全に削除（DOMを軽量化）
    var hoverImages = document.querySelectorAll('.js-pc-only-hover');
    hoverImages.forEach(function(img) {
      img.parentNode.removeChild(img);
    });
    console.log('[Hover] スマホ検出: ホバー画像を削除しました');
    return;
  }

  // PC用：ホバー画像を有効化
  console.log('[Hover] PC検出: ホバー画像を有効化します');

  var hoverImages = document.querySelectorAll('.js-pc-only-hover');
  
  hoverImages.forEach(function(img) {
    // data属性から実際の画像URLを取得
    var hoverSrc = img.getAttribute('data-hover-src');
    var hoverSrcset = img.getAttribute('data-hover-srcset');
    var hoverSizes = img.getAttribute('data-hover-sizes');

    if (hoverSrc) {
      // 画像を表示
      img.style.display = '';
      
      // 遅延読み込み：商品カードがビューポートに入った時に画像を読み込む
      var container = img.closest('.product-image-container');
      
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              // 画像属性を設定
              img.src = hoverSrc;
              if (hoverSrcset) img.srcset = hoverSrcset;
              if (hoverSizes) img.sizes = hoverSizes;
              
              // 監視を解除
              observer.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '200px 0px', // ビューポートの200px手前から読み込み開始
          threshold: 0
        });
        
        observer.observe(container || img);
      } else {
        // IntersectionObserver非対応ブラウザ：即座に読み込み
        img.src = hoverSrc;
        if (hoverSrcset) img.srcset = hoverSrcset;
        if (hoverSizes) img.sizes = hoverSizes;
      }
    }
  });
})();
